import axios from "axios";
import { MILESTONE_INVOICES_URL, milestoneInvoicesUrl } from "../utils";

export const fetchMilestoneInvoices = async (projectId?: string) => {
  if (!projectId) return await axios.get(MILESTONE_INVOICES_URL);

  return await axios.get(milestoneInvoicesUrl(projectId));
};
